import translations from './translations.js';

export default (
  twoFactorRequired,
  language = 'en_US'
) => {
  let data = {
    title: null,
    submitText: translations('submitText', language),
    showCancelButton: false,
    canClose: !twoFactorRequired,
  };
  return data;
};